import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LoginForm } from '@/pages/auth/LoginForm';
import {
  isFattahOneProductSelectionRequired,
  isPlatformOnboardingRequired,
} from '@/modules/onboarding/onboardingState';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { clearAuth } from '@/store/authSlice';
import { notify } from '@/core/toast/notify';
import { resolvePostLoginDestination } from '@/utils/postLoginNavigation';

export function FattahLoginPage() {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return (
    <LoginForm
      showRegisterLink
      onLoginSuccess={(result) => {
        if (result.masterAdmin) {
          dispatch(clearAuth());
          notify.error(t('errors.platformOperatorsMustUseTheMasterConsoleLogin'));
          return;
        }
        if (isFattahOneProductSelectionRequired()) {
          navigate('/onboarding/products', { replace: true });
          return;
        }
        if (isPlatformOnboardingRequired()) {
          navigate('/onboarding', { replace: true });
          return;
        }
        navigate(resolvePostLoginDestination(result), { replace: true });
      }}
    />
  );
}
